//user reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const LOADING_AUTHENTICATION = "LOADING_AUTHENTICATION";
export const AUTHORIZATION_TOKEN_SUCCESS = "AUTHORIZATION_TOKEN_SUCCESS";

export const AUTHENTICATED_INVITATION = "AUTHENTICATE_INVITATION";
export const SINGUP_USER = "SINGUP_USER";
export const SIGNING_USER = "SIGNING_USER";

export const SET_USER = "SET_USER";
export const LOADING_USER = "LOADING_USER";
export const SET_INVITATION = "SET_INVITATION";
export const SEND_INVITATION = "SEND_INVITATION";
export const CLEAR_INVITATION = "CLEAR_INVITATION";

export const REFRESH_TOKEN = "REFRESH_TOKEN";
